// pages/TicketPage.js — "Show my ticket": the attendee's ticket with its check-in code.  [marker: website-feed v1]
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const api = axios.create({ baseURL: '/api/public' });
const BLUE = '#003897';
const day = d => { const m = String(d || '').match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? new Date(+m[1], +m[2] - 1, +m[3]).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }) : ''; };
const t12 = t => { if (!t) return ''; const [h, m] = String(t).split(':'); const hh = parseInt(h, 10); return `${hh % 12 || 12}:${m || '00'} ${hh >= 12 ? 'PM' : 'AM'}`; };

export default function TicketPage() {
  const { token } = useParams();
  const [t, setT] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    api.get(`/ticket/${token}`).then(r => { if (!r.data || !r.data.event) throw new Error('bad'); setT(r.data); })
      .catch(e => setErr(e.response?.data?.error || 'This ticket could not be loaded. Please call NJJBA at 201-472-5120.'));
  }, [token]);
  const place = t ? [t.event.venue, t.event.location_address].filter(Boolean).join(', ') : '';
  return (
    <div style={{ minHeight: '100vh', background: '#f3f5f9', fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif', color: '#1f2937' }}>
      <div style={{ background: BLUE, color: '#fff', padding: 16 }}><div style={{ maxWidth: 480, margin: '0 auto', fontWeight: 600 }}>New Jersey Jewish Business Alliance</div></div>
      <div style={{ maxWidth: 480, margin: '0 auto', padding: '20px 16px 40px' }}>
        {!t && !err && <p>Loading your ticket…</p>}
        {err && <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 18 }}>{err}</div>}
        {t && (
          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 14, overflow: 'hidden' }}>
            <div style={{ padding: '18px 20px', borderBottom: '1px dashed #cbd5e1' }}>
              <div style={{ fontSize: 13, color: '#6b7280' }}>Ticket for</div>
              <div style={{ fontSize: 20, fontWeight: 700, margin: '2px 0 8px' }}>{t.event.name}</div>
              <div style={{ fontSize: 15 }}>{day(t.event.event_date)}{t.event.start_time ? `, ${t12(t.event.start_time)}${t.event.end_time ? ` – ${t12(t.event.end_time)}` : ''}` : ''}</div>
              {place && <div style={{ fontSize: 15, marginTop: 4 }}>{place}{' '}
                <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(place)}`} target="_blank" rel="noopener noreferrer" style={{ color: BLUE, fontWeight: 600 }}>Directions</a></div>}
            </div>
            <div style={{ padding: 20, textAlign: 'center' }}>
              {t.status === 'valid' ? (
                <>
                  <img src={t.qr} alt="Check-in code" style={{ width: 220, height: 220, imageRendering: 'pixelated' }} />
                  <div style={{ fontSize: 18, fontWeight: 700, marginTop: 8 }}>{t.name}</div>
                  <div style={{ fontSize: 14, color: '#6b7280' }}>{t.ticket_type} · {t.ticket_number}</div>
                  <div style={{ fontSize: 14, marginTop: 12, color: t.checked_in ? '#15803d' : '#374151' }}>
                    {t.checked_in ? '✓ Checked in. Enjoy the event!' : 'Show this code at the door, or just give your name.'}
                  </div>
                </>
              ) : (
                <div style={{ fontSize: 15 }}>{t.status === 'refunded' ? 'This ticket was refunded and is no longer valid.' : 'This ticket is not paid yet. Please complete payment, or call 201-472-5120.'}</div>
              )}
            </div>
            <div style={{ padding: '12px 20px', background: '#f8fafc', borderTop: '1px solid #e5e7eb', textAlign: 'center', fontSize: 14 }}>
              <a href={`/api/public/events/${t.event.id}/calendar.ics`} style={{ color: BLUE, fontWeight: 600 }}>Add to my calendar</a>
            </div>
          </div>
        )}
        <p style={{ fontSize: 13, color: '#6b7280', textAlign: 'center', marginTop: 16 }}>Questions? Call 201-472-5120 or email info@njjba.com.</p>
      </div>
    </div>
  );
}
